/* Samedi storefront JS: AJAX add-to-cart, variant price, localStorage wishlist, promo */
(function () {
  var routes = window.routes || {};
  var cartAddUrl = routes.cart_add_url || '/cart/add';

  /* 19Sep2026: the currency was hardcoded to GBP here, so the bag drawer, its line prices,
     the total and the Checkout button always printed pounds, while Shopify converts the
     prices Liquid renders on the product page for visitors outside the UK (Rest of World
     market has local currencies on). An overseas visitor saw dollars on the product page
     and pounds in the bag. /cart.js already returns amounts in the visitor's presentment
     currency, so all this needs is the active currency rather than a fixed one. */
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    var loc = cur === 'GBP' ? 'en-GB' : undefined;
    try {
      return (cents / 100).toLocaleString(loc, { style: 'currency', currency: cur }).replace(/\.00$/, '');
    } catch (e) {
      return (cents / 100).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' }).replace(/\.00$/, '');
    }
  }

  /* ---------- cart count badge ---------- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('a[data-cart-link]').forEach(function (link) {
          var badge = link.querySelector('.cart-count');
          if (cart.item_count > 0) {
            if (!badge) { badge = document.createElement('span'); badge.className = 'cart-count'; link.appendChild(badge); }
            badge.textContent = cart.item_count;
          } else if (badge) { badge.remove(); }
        });
      });
  }

  /* ---------- Clarity custom events ----------
     ⚠️ 03Sep2026 I moved add to cart to AJAX (preventDefault + fetch) so the page no
     longer navigates. Clarity's auto-detected Smart Events are inferred from real
     navigations and form posts, so from that day add-to-cart and checkout stopped
     being recorded. The theme had ZERO clarity() calls, so nothing replaced the signal.

     ⚠️ 12Sep2026 I WAS WRONG ABOUT A RACE. I claimed Clarity's tag was async and could
     load after this file. It cannot: the Clarity stub is an INLINE script in <head>
     (verified, offset 35347 against </head> at 64723) so window.clarity is always
     defined before this deferred file runs. The stub also buffers into clarity.q until
     the real tag drains it. The queue below is therefore belt-and-braces, not a fix —
     the original empty dashboard was ingestion latency, not dropped events. */
  var _ceQueue = [];
  function _ceFlush() {
    if (typeof window.clarity !== 'function') return false;
    while (_ceQueue.length) {
      var it = _ceQueue.shift();
      try {
        /* tags are SESSION-scoped in Clarity, not event properties, so they must be set
           before the event and named as session facts, never as per-event data. */
        if (it.data) Object.keys(it.data).forEach(function (k) {
          window.clarity('set', k, String(it.data[k]));
        });
        window.clarity('event', it.name);
      } catch (err) { /* never let analytics break the page */ }
    }
    return true;
  }
  function ce(name, data) {
    _ceQueue.push({ name: name, data: data });
    if (_ceFlush()) return;
    var tries = 0;
    var t = setInterval(function () {
      if (_ceFlush() || ++tries > 60) clearInterval(t);   /* give up after ~18s */
    }, 300);
  }

  /* ---------- Shopify's pixel bus ----------
     A theme CANNOT call fbq or gtag directly. The Meta and Google pixels run inside
     Shopify's Web Pixels sandbox and only subscribe to Shopify's own standard events.
     `Shopify.analytics.publish` puts a custom event on that bus, and it is the only route
     that exists from theme code to an app pixel.

     ⚠️ META WILL NOT PICK THESE UP BY ITSELF. Meta's InitiateCheckout already fires from
     Shopify's STANDARD `checkout_started` when the checkout page loads, and that covers
     both the Checkout button and the wallets, because a wallet also creates a checkout. To
     get these drawer-level events into Meta specifically, a Custom Pixel has to be added in
     admin that subscribes to them and forwards them. Publishing them here is what makes
     that possible without another theme change. */
  function sa(name, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload || {});
      }
    } catch (err) { /* never let analytics break the page */ }
  }

  /* Product view. Clarity used to infer this from the navigation; it still sees the
     pageview, but the e-commerce event needs firing explicitly so it can be used as a
     Smart Event. Fires once per product page load. */
  if (/\/products\//.test(location.pathname) && document.querySelector('#atc-form')) {
    var _h = location.pathname.split('/products/')[1];
    ce('product_view', _h ? { last_product: _h.split(/[?#]/)[0] } : null);
  }

  /* Checkout intent. Covers both routes out of the site: the cart page button, and the
     express wallet on the product page, which skips the cart entirely and so was never
     going to be caught by a cart-page rule. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    /* Which surface the click came from. There are now three ways out of the site, and
       telling them apart is the whole point of measuring this: the bag drawer, the full cart
       page, and the wallet on the product page. Event NAMES are deliberately unchanged so
       the Smart Events already built in the Clarity dashboard keep working.
       ⚠️ Clarity tags are SESSION scoped, not per event, so these read as session facts. */
    var surface = t.closest('.scd') ? 'drawer' : (/^\/cart/.test(location.pathname) ? 'cart_page' : 'other');
    if (t.closest('[name=checkout], .cart__checkout-button, a[href*="/checkout"]')) {
      ce('checkout_started_cart', { checkout_surface: surface });
      sa('checkout_click', { surface: surface });
    } else if (t.closest('shopify-accelerated-checkout, shopify-accelerated-checkout-cart')) {
      /* ⚠️ Only the unbranded "Buy it now" fallback is really caught here. When the wallet
         is PayPal it renders in a CROSS-ORIGIN IFRAME, and clicks inside it produce no
         event in this document at all — nothing to listen for. Express checkout is
         therefore UNDER-reported and must be read from Shopify, not Clarity. Deliberately
         NOT matching .pdp-express: that wrapper is a full-width block whose padding and
         loading skeleton generated false positives. */
      ce('checkout_started_express', { express_surface: t.closest('.scd') ? 'drawer' : 'pdp' });
      sa('express_checkout_click', { surface: t.closest('.scd') ? 'drawer' : 'pdp' });
    }
  }, true);

  /* ---------- cart drawer ----------
     12Sep2026, second pass. The first fix navigated to /cart on add. It worked, but
     Ilyas tested it on a phone and it reads as being thrown off the product page.
     So: keep the shopper on the PDP and slide the bag in from the right, showing what
     they just added plus a Checkout button. The original problem is still solved,
     because the shopper now SEES a next step instead of a 1700ms tick.

     Built in JS from /cart.js rather than as a Liquid section, so there is nothing to
     keep in sync with the cart template and it always reflects the real cart. It
     reuses the cart page's own .cart-row / .ci-* / .qty classes, so there is one
     visual language, not two.

     No promo field and no coupon panel in here, unlike the reference screenshot:
     Samedi's promo code works by navigating through /discount, which would defeat the
     point of staying on the page, and Samedi is deliberately not discount-led. The
     full bag still has both. */
  var scd = null, scdFocusReturn = null;

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------- delivery estimate ----------
     Baymard guideline 543: show an estimated delivery DATE, not a speed.

     ⭐ THE RULE, set by Ilyas 12 Sep 2026, verbatim: "For weekends, say Mon/Tues. For Friday
     say Sat/Mon. For other weekdays, say the next day or day after. I do next working day."

     That is one clean rule: show the NEXT TWO DELIVERY DAYS after the order, where a
     delivery day is Monday to SATURDAY, excluding bank holidays. Saturday delivery counts,
     Sunday does not. Check it reproduces every case he gave:
       Mon -> Tue, Wed     Tue -> Wed, Thu     Wed -> Thu, Fri     Thu -> Fri, Sat
       Fri -> Sat, Mon     Sat -> Mon, Tue     Sun -> Mon, Tue

     ⛔ Do NOT reintroduce a "dispatch on the next working day" step. An earlier version added
     one and pushed every date a day late.

     Bank holidays are the official England and Wales list from gov.uk/bank-holidays.json,
     fetched 12 Sep 2026. ⚠️ EXTEND THIS LIST before Jan 2028 or the estimate drifts
     optimistic around Christmas. */
  var SCD_BANK_HOLIDAYS = [
    '2026-12-25', '2026-12-28', '2027-01-01', '2027-03-26', '2027-03-29',
    '2027-05-03', '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28'
  ];

  function scdIsDeliveryDay(d) {
    if (d.getDay() === 0) return false;            /* no Sunday delivery */
    var iso = d.getFullYear() + '-' +
      ('0' + (d.getMonth() + 1)).slice(-2) + '-' +
      ('0' + d.getDate()).slice(-2);
    return SCD_BANK_HOLIDAYS.indexOf(iso) === -1;
  }

  function scdNextDeliveryDay(from) {
    var out = new Date(from.getTime());
    var guard = 0;
    do {
      out.setDate(out.getDate() + 1);
      guard++;
    } while (!scdIsDeliveryDay(out) && guard < 30);
    return out;
  }

  function scdArrivalLine() {
    try {
      var first = scdNextDeliveryDay(new Date());
      var second = scdNextDeliveryDay(first);
      var fmt = function (d) {
        return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
      };
      return 'Arrives ' + fmt(first) + ' or ' + fmt(second);
    } catch (err) {
      /* never let a date bug break the bag */
      return 'Arrives next day or the day after';
    }
  }

  function scdThumb(item) {
    var u = item.image || (item.featured_image && item.featured_image.url) || '';
    if (!u) return '';
    u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=228';
    return '<img src="' + esc(u) + '" alt="" width="76" height="76" loading="lazy">';
  }

  /* 15Sep2026, approved by Ilyas: a display-only "Gift box" row under the line items.
     It is NOT a cart line: no link, no quantity, no Remove, nothing posted to /cart, so
     item_count, the total and checkout are untouched.
     The image is the packaging shot from every product gallery (pkg-v5-studio-flat.jpg),
     exposed as window.samediPackImg by layout/theme.liquid. If that URL is missing the row
     is skipped entirely rather than rendered without its image: an empty div computes to
     display:none on this storefront, and a half-built row would look broken. */
  function scdPackRow() {
    var u = window.samediPackImg;
    if (!u || typeof u !== 'string') return '';
    return '<div class="cart-row cart-row--pack">' +
      '<div class="ci-img ph"><img src="' + esc(u) + '" alt="" width="76" height="76" loading="lazy"></div>' +
      '<div class="ci-info">' +
        '<div class="ci-top">' +
          '<div>' +
            '<div class="ci-name">Gift box</div>' +
            '<div class="ci-meta">Pouch, polishing cloth and care card</div>' +
          '</div>' +
          '<div class="ci-price">Included</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function scdBuild() {
    if (scd) return scd;
    if (!document.body) return null;
    scd = document.createElement('div');
    scd.className = 'scd';
    scd.hidden = true;
    /* No separate scrim element on purpose. An empty <div> scrim computed to
       display:none on this storefront, so tap-outside-to-close silently did
       nothing: something in the loaded CSS hides empty divs and outranks a single
       class selector. Verified in the browser: matches('div:empty') was true, and
       giving the div a child flipped computed display from none to block. The
       backdrop now lives on .scd itself, which always has children, so the bug
       cannot come back. Closing on backdrop tap is handled by geometry below. */
    scd.innerHTML =
      '<aside class="scd-panel" role="dialog" aria-modal="true" aria-label="Your bag">' +
        '<header class="scd-head">' +
          '<h2 class="scd-title">Your bag <span data-scd-count></span></h2>' +
          '<button type="button" class="scd-x" data-scd-close aria-label="Close bag">&times;</button>' +
        '</header>' +
        '<div class="scd-body" data-scd-body></div>' +
        /* One bottom block, three containers. scdRender rewrites .scd-foot and
           .scd-tail on every change but NEVER .scd-xpay. The Shopify wallet element
           installs a PerformanceObserver in connectedCallback and keeps itself in sync
           with the cart, so re-creating it on every quantity tap would re-initialise it,
           flash a skeleton and cost a round trip for nothing. */
        '<div class="scd-bottom">' +
          '<div class="scd-foot" data-scd-foot></div>' +
          '<div class="scd-xpay" data-scd-xpay></div>' +
          '<div class="scd-tail" data-scd-tail></div>' +
        '</div>' +
      '</aside>';
    document.body.appendChild(scd);

    scd.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-scd-close]')) { scdClose(); return; }
      var q = t.closest('[data-scd-line]');
      if (q) {
        e.preventDefault();
        scdChange(q.getAttribute('data-scd-line'), q.getAttribute('data-scd-qty'), q);
        return;
      }
      /* tapped the darkened strip of page beside the panel */
      if (!t.closest('.scd-panel')) scdClose();
    });
    return scd;
  }

  function scdRender(cart) {
    if (!scd) return;
    var count = scd.querySelector('[data-scd-count]');
    var body = scd.querySelector('[data-scd-body]');
    var foot = scd.querySelector('[data-scd-foot]');
    var tail = scd.querySelector('[data-scd-tail]');
    var xpay = scd.querySelector('[data-scd-xpay]');
    var n = cart.item_count || 0;

    count.textContent = n ? '· ' + n + ' item' + (n === 1 ? '' : 's') : '';

    if (!n) {
      body.innerHTML = '<p class="scd-empty">Your bag is empty.</p>';
      foot.innerHTML = '<a class="btn btn-primary btn-block" href="/collections/mens-bracelets">Shop the Classics</a>';
      tail.innerHTML = '';
      /* no cart, so no wallets: Shopify's element has nothing to check out */
      xpay.innerHTML = '';
      xpay.classList.remove('is-loading');
      return;
    }

    body.innerHTML = cart.items.map(function (item, i) {
      var line = i + 1;
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? esc(item.variant_title) + ' · ' : '';
      return '<div class="cart-row">' +
        '<a href="' + esc(item.url) + '" class="ci-img ph">' + scdThumb(item) + '</a>' +
        '<div class="ci-info">' +
          '<div class="ci-top">' +
            '<div>' +
              '<a href="' + esc(item.url) + '" class="ci-name">' + esc(item.product_title) + '</a>' +
              '<div class="ci-meta">' + variant + 'Solid 925</div>' +
            '</div>' +
            '<div class="ci-price">' + money(item.final_line_price) + '</div>' +
          '</div>' +
          '<div class="ci-bottom">' +
            '<div class="qty">' +
              /* At quantity 1 the minus button would post quantity=0 and wipe the line
                 with no confirmation and no undo, then the footer would swap to the empty
                 state. On a phone that is one fat-finger away from losing the selection,
                 so it is disabled instead. Remove is still there and is explicit. */
              '<button type="button" aria-label="Decrease quantity" data-scd-line="' + line + '" data-scd-qty="' + (item.quantity - 1) + '"' + (item.quantity < 2 ? ' disabled' : '') + '>−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" aria-label="Increase quantity" data-scd-line="' + line + '" data-scd-qty="' + (item.quantity + 1) + '">+</button>' +
            '</div>' +
            '<button type="button" class="ci-remove" data-scd-line="' + line + '" data-scd-qty="0">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('') + scdPackRow();

    /* ⛔ 12Sep2026: a four line trust list used to sit here, filling the gap under the
       items. Ilyas: "This trust lines look shit, remove them." Removed. The gap is back and
       that is fine, the footer is bottom anchored for thumb reach either way.
       ⛔ Do not re-add reassurance copy to the bag body. The material, length and returns
       terms are all on the product page, which is where the shopper reads them.
       15Sep2026: the "Gift box" row added just above by scdPackRow() is NOT that trust list
       coming back. It is a display-only line item Ilyas approved: every order includes the
       box, pouch, polishing cloth and care card, shown with its image and "Included" where a
       price would be. It is not a cart line, has no controls and changes no counts. */

    /* "Subtotal" implies charges still to come, which is the exact fear to avoid here:
       unexpected extra cost is the best-evidenced abandonment cause there is, at 40% in
       Baymard's data. So the label is TOTAL and the note says plainly that nothing more
       gets added.
       ⚠️ NOT "Tax included", which the full bag page says: Samedi is not VAT registered,
       so there is no output VAT to include and the claim would be wrong. */
    foot.innerHTML =
      '<div class="scd-sum"><span>Total</span><span>' + money(cart.total_price) + '</span></div>' +
      '<p class="scd-note">Free UK delivery. No extra charges at checkout.</p>' +
      /* 13Sep2026, Ilyas: keep the note, add small print for international buyers. */
      '<p class="scd-fine">International delivery and import charges may apply.</p>' + /* 14Sep2026 [design-14sep]: "Applies to UK orders" removed, Ilyas: redundant */
      '<p class="scd-arrival">' + scdArrivalLine() + '</p>' +
      '<a class="btn btn-primary btn-block" href="/checkout">Checkout · ' + money(cart.total_price) + '</a>';

    /* Kept as the escape hatch for the minority who want the full page. The two reviews
       disagreed about this link: one wanted it gone because it leads to a page offering
       "Add a discount code" on a brand that is deliberately not discount led, the other
       wanted it kept as a way out. Keeping it, because the header bag icon now opens this
       drawer, so removing it would leave /cart reachable only by typing the URL.
       ⚠️ The discount field on /cart is a real point and is Ilyas's call. */
    tail.innerHTML =
      '<a class="scd-view" href="' + (routes.cart_url || '/cart') + '">View full bag</a>';
  }

  function scdChange(line, quantity, srcBtn) {
    if (srcBtn) srcBtn.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { scdRender(cart); refreshCartCount(); })
      .catch(function () { if (srcBtn) srcBtn.disabled = false; });
  }

  function scdKey(e) {
    if (e.key === 'Escape' || e.keyCode === 27) { scdClose(); return; }
    if (e.key !== 'Tab' || !scd || scd.hidden) return;
    var f = scd.querySelectorAll('a[href], button:not([disabled])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- express wallets ----------
     Apple Pay, PayPal and Google Pay, pulled in over the Section Rendering API from
     sections/samedi-xpay.liquid. Shopify documents this as the supported way to get
     accelerated checkout buttons into a cart drawer.

     Fetched ONCE per pageview, never per render: the element tracks the cart itself, so
     re-fetching would re-initialise it for nothing. Any failure is silent by design, the
     plain Checkout button above is untouched and is always the real path. */
  var scdXpayState = 'idle';

  function scdXpayLoad() {
    if (scdXpayState !== 'idle') return;
    var mount = scd && scd.querySelector('[data-scd-xpay]');
    if (!mount) return;
    scdXpayState = 'loading';
    /* reserve the height while it loads so the Checkout button does not jump under a
       thumb that is already moving toward it. Released either way when we settle. */
    mount.classList.add('is-loading');
    /* ⚠️ NO `Accept: application/json` HEADER. On a product URL that header makes Shopify
       answer with the PRODUCT as JSON and ignore `?sections=` entirely, so the fetch
       returns 200 with a body that has no section in it. Cost an hour to spot, because the
       request looks perfectly healthy. The Section Rendering API sets a JSON content type
       by itself.
       Fetching from the root rather than the current path for the same reason: the root has
       no product to collide with. The wallet markup is cart scoped, not page scoped, so the
       path it is rendered from does not matter. */
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?sections=samedi-xpay')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['samedi-xpay'];
        if (!html) throw new Error('no section html');
        mount.innerHTML = html;
        scdXpayState = 'done';
        mount.classList.remove('is-loading');
        /* Inserting the markup upgrades the custom element on its own once it is defined.
           Only kick the initialiser when the element has not been registered yet. */
        if (!window.customElements || !customElements.get('shopify-accelerated-checkout-cart')) {
          if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) {
            try { window.Shopify.PaymentButton.init(); } catch (err) {}
          }
        }
      })
      .catch(function () {
        scdXpayState = 'failed';
        mount.innerHTML = '';
        mount.classList.remove('is-loading');
      });
  }

  function scdOpen(source) {
    if (!scdBuild()) return false;
    scdFocusReturn = document.activeElement;
    scd.hidden = false;
    /* one frame with the panel still translated off-screen, so the slide actually animates */
    requestAnimationFrame(function () { scd.classList.add('is-open'); });
    document.documentElement.classList.add('scd-open');
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        scdRender(cart);
        if (cart.item_count > 0) scdXpayLoad();
        /* The bag opening is now its own funnel step, between add to cart and checkout.
           Without it there is no way to tell "nobody opens the bag" from "people open it
           and leave", which is exactly the question that mattered before the drawer existed. */
        ce('cart_drawer_opened', { drawer_source: source || 'unknown' });
        sa('cart_drawer_opened', { source: source || 'unknown', item_count: cart.item_count });
        var x = scd.querySelector('.scd-x');
        if (x) x.focus();
      })
      .catch(function () {});
    document.addEventListener('keydown', scdKey);
    return true;
  }

  function scdClose() {
    if (!scd) return;
    scd.classList.remove('is-open');
    document.documentElement.classList.remove('scd-open');
    document.removeEventListener('keydown', scdKey);
    var el = scd;
    setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 340);
    if (scdFocusReturn && scdFocusReturn.focus) { try { scdFocusReturn.focus(); } catch (err) {} }
  }

  /* Tapping the header bag opens the drawer instead of leaving the page. The link
     still points at /cart, so if this JS ever fails to load the bag is still reachable. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('a[data-cart-link]')) return;
    if (/^\/cart/.test(location.pathname)) return;          /* already on the full bag */
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.which === 2) return;  /* let new-tab work */
    if (scdOpen('bag_icon')) e.preventDefault();
  });

  /* ---------- add to cart: AJAX post, then open the bag drawer ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('#atc-form, .bcard-quick-form, .bcard-add-form')) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    /* Capture the pristine label ONCE per button, not per submit. Capturing it per
       submit meant a second tap inside the 1700ms restore window captured the
       transient "Added ✓" and then restored to THAT permanently, so the customer
       lost the "Add to cart · £200" call to action and the price for the rest of the
       pageview. Impatient double-tapping is common on mobile. Also affects the
       quick-add buttons on collection cards, not just the PDP. */
    if (btn && btn.dataset.pristineLabel === undefined) btn.dataset.pristineLabel = btn.innerHTML;
    var original = btn ? btn.dataset.pristineLabel : '';
    /* and cancel any restore still pending, so rapid taps cannot stack timers */
    if (btn && btn._restoreT) { clearTimeout(btn._restoreT); btn._restoreT = null; }
    if (btn) btn.disabled = true;
    fetch(cartAddUrl, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        /* ---- add failed: stay put, say why ---- */
        if (!res.ok) {
          if (btn) {
            btn.disabled = false;
            btn.innerHTML = (res.j && res.j.description) || 'Unavailable';
            btn._restoreT = setTimeout(function () { btn.innerHTML = original; }, 1700);
          }
          return;
        }

        /* ---- add succeeded: HAND THE SHOPPER TO THE BAG ----
           12Sep2026. Until today a successful add showed "Added ✓" for 1700ms plus a
           16px header badge, and that was the whole handoff: no drawer, no navigation,
           no checkout call to action. Measured result across three sources: 14 adds to
           cart produced 2 checkouts over 7-12 Sep and ZERO since 9 Sep, Shopify held 2
           abandoned checkouts since 25 Aug, and Clarity showed 1.33 pages per session.
           Nobody was reaching /cart.

           Why navigate rather than build a drawer: traffic is 98.4% mobile, the
           catalogue is 5 SKUs and pages per session is 1.33, so there is no browsing
           momentum for a drawer to protect. The only device-split A/B data available
           has drawers LOSING on mobile, worst on small catalogues (-8.4% conversion,
           -10% revenue per session), while winning on desktop, which Samedi barely
           has. /cart already carries the wallet buttons, a "Checkout · total" button,
           the payment icons and a continue-shopping link, so it is the stronger
           surface for a considered £125-200 single-item purchase.

           Navigating also restores what the 03Sep AJAX change removed: a real
           navigation, which is what Clarity's native e-commerce inference reads. */
        var pid = form.querySelector('[name=id]:checked') || form.querySelector('[name=id]');
        ce('add_to_cart', pid ? { last_atc_variant: pid.value } : null);
        refreshCartCount();

        if (btn) {
          /* leave the button disabled: we are navigating, and a second tap in the
             gap would add a second bracelet the shopper did not ask for */
          if (btn.matches('.card-quick, .bcard-quick')) {
            btn.classList.add('added');
            btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
          } else {
            btn.innerHTML = 'Added ✓';
          }
        }

        /* Open the bag beside the page. If the drawer cannot be built for any reason,
           fall back to navigating, so a shopper is never left with no next step. */
        if (!scdOpen('add_to_cart')) {
          window.location.href = routes.cart_url || '/cart';
          return;
        }

        /* We are staying on the page, so give the button back. 1700ms matches the
           pristine-label handling above. */
        setTimeout(function () {
          if (btn) { btn.disabled = false; btn.classList.remove('added'); btn.innerHTML = original; }
        }, 1700);
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
  });

  /* ---------- PDP variant price ---------- */
  /* ---------- product page arrival date ----------
     Same function the bag uses, so the product page and the bag can never disagree about
     delivery. Before this they were 40px apart in the funnel saying different things: the
     page said "dispatched today" as a hardcoded string with no weekday logic, on a Saturday
     when nothing ships. */
  document.querySelectorAll('[data-arrival]').forEach(function (el) {
    el.textContent = scdArrivalLine();
  });

  var variants = window.samediVariants;
  if (variants) {
    var priceEl = document.querySelector('[data-price]');
    var atcPriceEl = document.querySelector('[data-atc-price]');
    /* ⚠️ The sticky mobile bar. It rendered cv.price ONCE from Liquid and nothing ever
       updated it, so on Atlas Figaro (£125 / £170) and Onyx Cuban (£165) choosing a second
       size left the primary mobile button quoting one price while the form submitted a
       different variant. Displayed price versus charged price, on the button 98.4% of
       traffic uses. */
    var mPriceEl = document.querySelector('.m-price');
    /* [21sep-stock] Same row Liquid renders server-side for the default variant (see
       samedi-product.liquid, the comment above `.rating-row`'s closing tag), rebuilt here so
       switching width without a reload keeps telling the truth about THIS variant's stock, not
       the one the page loaded with. Threshold (3 or fewer) and wording ("Only X left") match. When
       healthy, the element is removed outright, not hidden, so it costs no height either way. */
    var FLAME_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 2s5 5 5 9a5 5 0 0 1-10 0c0-1.5 1-3 1-3s1 1.5 2 1.5S12 5 12 2z"/></svg>';
    /* ==================================================================
       [stockpill-21sep] THE LOW-STOCK PILL: reveal, dismiss, remember, and keep in step with the
       variant switcher. 20Sep2026, Ilyas wanted the warning out of the rating row and floating on
       the page as a pill with an X.

       ⛔ NOTHING HERE TOUCHES LAYOUT. The pill is position:fixed, so showing, hiding and
       dismissing it cannot move the buy column by a pixel. That is why the low-stock products now
       measure identical to live.

       ⚠️ sessionStorage throws outright in a private window and when site data is blocked, so
       every read and every write is wrapped. A throw must mean "not dismissed" and keep the pill
       working, never break the page.
       ⚠️ Dismissal is remembered for the SESSION and is deliberately not per product: being told
       the same thing on the next page after saying no is the behaviour people find hostile.
       ================================================================== */
    var PILL = (function () {
      var pill = document.querySelector('[data-stockpill]');
      if (!pill) return { sync: function () {} };
      var KEY = 'samedi_stockpill_dismissed';
      var txEl = pill.querySelector('[data-stockpill-tx]');
      var closeEl = pill.querySelector('[data-stockpill-close]');
      var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      var DELAY = 2500, OUT = 420;
      var revealTimer = null, hideTimer = null, live = false;

      function dismissed() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
      function remember() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }

      function show() {
        if (dismissed() || live) return;
        if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
        live = true;
        pill.hidden = false;
        if (mq && mq.matches) { pill.classList.add('is-in'); return; }
        /* two frames: the first commits `hidden` being gone and the starting opacity, the second
           starts the transition. One frame is not reliably enough and the pill snaps in. */
        requestAnimationFrame(function () { requestAnimationFrame(function () { pill.classList.add('is-in'); }); });
      }

      /* `forget` false = the variant no longer qualifies, so it may come back on a switch back.
         `forget` true = the visitor dismissed it, so it must not. */
      function hide(forget) {
        if (forget) remember();
        if (revealTimer) { clearTimeout(revealTimer); revealTimer = null; }
        if (!live) { pill.hidden = true; return; }
        live = false;
        pill.classList.remove('is-in');
        if (hideTimer) clearTimeout(hideTimer);
        hideTimer = setTimeout(function () { pill.hidden = true; hideTimer = null; }, OUT);
      }

      if (closeEl) closeEl.addEventListener('click', function () { hide(true); });
      document.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc') && live) {
          /* ⚠️ the size guide and the cart drawer both close on Escape too. They are modal and own
             the key while open, so the pill only takes it when neither is up. */
          if (document.documentElement.classList.contains('scd-open')) return;
          var sg = document.querySelector('.sg-modal');
          if (sg && !sg.hasAttribute('hidden')) return;
          hide(true);
        }
      });

      if (!dismissed()) revealTimer = setTimeout(show, DELAY);

      return {
        /* Called after every variant switch. A variant with a healthy count retires the pill
           WITHOUT remembering, so switching back can bring it up again; a dismissed pill stays
           dismissed either way because show() checks. */
        sync: function (v) {
          var low = (v.available !== false && typeof v.qty === 'number' && v.qty > 0 && v.qty <= 3);
          if (!low) { hide(false); return; }
          if (txEl) txEl.textContent = 'Only ' + v.qty + ' left' + (/mm$/.test(v.title || '') ? ' in ' + v.title : '');
          if (dismissed()) return;
          if (live) return;
          if (revealTimer) { clearTimeout(revealTimer); revealTimer = null; }
          show();
        }
      };
    })();

    /* The out-of-stock line is the only stock message still in the rating row. It is static, it
       is never a pill, and it is rebuilt here on a variant switch exactly as before. */
    function updateStockLine(v) {
      var ratingRow = document.querySelector('.pdp .rating-row');
      if (!ratingRow) return;
      var existingOut = ratingRow.querySelector('[data-stock-line]');
      if (existingOut) existingOut.remove();
      if (v.available === false) {
        ratingRow.insertAdjacentHTML('beforeend', '<div class="stock-line stock-out" data-stock-line>Currently unavailable</div>');
      }
      PILL.sync(v);
    }
    document.querySelectorAll('.pdp .sizes input[name=id]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var v = variants[radio.value];
        if (!v) return;
        if (priceEl) priceEl.textContent = v.price;
        if (atcPriceEl) atcPriceEl.textContent = v.priceShort;
        /* the sticky mobile bar, previously never updated. priceShort matches the format
           Liquid rendered it with (money_without_trailing_zeros). */
        if (mPriceEl) mPriceEl.textContent = v.priceShort;
        var wEl = document.querySelector('[data-spec-weight]');
        if (wEl && v.weight) wEl.textContent = v.weight;
        updateStockLine(v);
      });
    });
  }

  /* ---------- Wishlist (localStorage) ---------- */
  var WKEY = 'samedi_wishlist';
  function wlGet() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function wlSet(a) { localStorage.setItem(WKEY, JSON.stringify(a)); }
  function wlHas(h) { return wlGet().indexOf(h) > -1; }
  function wlToggle(h) { var a = wlGet(), i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.push(h); wlSet(a); return a.indexOf(h) > -1; }

  function markHearts() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      b.classList.toggle('is-saved', wlHas(b.getAttribute('data-handle')));
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    var nowSaved = wlToggle(b.getAttribute('data-handle'));
    b.classList.toggle('is-saved', nowSaved);
    // On the wishlist page, un-saving removes the card
    var wlGridEl = document.querySelector('[data-wishlist-grid]');
    if (!nowSaved && wlGridEl) {
      var card = b.closest('.bcard, .card');
      if (card) card.remove();
      var emptyEl = document.querySelector('[data-wishlist-empty]');
      if (!wlGridEl.querySelector('.bcard, .card') && emptyEl) emptyEl.style.display = '';
    }
  });
  markHearts();

  /* ---------- Wishlist page render ---------- */
  var grid = document.querySelector('[data-wishlist-grid]');
  if (grid) {
    var handles = wlGet();
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!handles.length) { if (empty) empty.style.display = ''; }
    else {
      if (empty) empty.style.display = 'none';
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        var heart = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 1 0-7.8 7.8l1 1.1L12 21.2l7.8-7.8 1-1.1a5.5 5.5 0 0 0 0-7.7z"/></svg>';
        var shield = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 2 4 6v6c0 5 3.5 8 8 10 4.5-2 8-5 8-10V6z"/><path d="m9 12 2 2 4-4"/></svg>';
        products.filter(Boolean).forEach(function (p) {
          var art = document.createElement('article');
          art.className = 'bcard';
          var img = p.featured_image ? (p.featured_image.indexOf('?') > -1 ? p.featured_image + '&width=800' : p.featured_image + '?width=800') : '';
          /* [design-14sep] PRICE RULE, Ilyas's decision 14 Sep 2026: lowest price across ALL
             variants, sold out or not, with "from" when prices vary. "From £135" is true if the
             cheapest variant is £135 even when it is out of stock. Reverts the 13 Sep
             available-only rule. Keep in step with samedi-bcard, samedi-card, samedi-startpick. */
          var allPrices = (p.variants || []).map(function (v) { return v.price; });
          var pMin = allPrices.length ? Math.min.apply(null, allPrices) : p.price;
          var pMax = allPrices.length ? Math.max.apply(null, allPrices) : p.price_max;
          var pLabel = (pMax > pMin ? '<small>from</small>' : '') + money(pMin);
          art.innerHTML =
            '<div class="bcard-media">' +
              '<button class="bcard-fav is-saved" type="button" data-wishlist-toggle data-handle="' + p.handle + '" aria-label="Remove from wishlist">' + heart + '</button>' +
              '<a href="/products/' + p.handle + '">' + (img ? '<img src="' + img + '" alt="' + p.title + '" loading="lazy">' : '') + '</a>' +
              '<span class="bcard-auth">' + shield + '925 · Hallmarked</span>' +
            '</div>' +
            '<div class="bcard-body">' +
              '<div class="bcard-top"><a href="/products/' + p.handle + '"><span class="bcard-name">' + p.title + '</span></a><span class="bcard-price">' + pLabel + '</span></div>' +
              '<div class="bcard-meta"><span class="bcard-price-m">' + pLabel + '</span></div>' +
              '<a href="/products/' + p.handle + '" class="bcard-add" style="display:block;text-align:center">View product</a>' +
            '</div>';
          grid.appendChild(art);
        });
      });
    }
  }

  /* ---------- Promo code -> Shopify discount session (carries to checkout) ---------- */
  var promo = document.querySelector('[data-promo-form]');
  if (promo) {
    var applyPromo = function () {
      var input = promo.querySelector('input');
      var code = input && input.value ? input.value.trim() : '';
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    };
    var pbtn = promo.querySelector('[data-promo-apply]');
    if (pbtn) pbtn.addEventListener('click', applyPromo);
    var pinput = promo.querySelector('input');
    if (pinput) pinput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyPromo(); } });
  }
  // Remove an applied discount code (clears the cart's discount session, then reloads)
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-promo-remove]');
    if (!rm) return;
    e.preventDefault();
    rm.disabled = true;
    fetch('/discount?discount=', { method: 'GET' })
      .catch(function () {})
      .then(function () {
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) }).catch(function () {});
      })
      .then(function () { window.location.href = '/cart'; });
  });

  /* ---------- Read-a-review modal (PDP review cards) ---------- */
  var rvrModal = document.getElementById('rvrModal');
  if (rvrModal) {
    var rvrStars = rvrModal.querySelector('[data-rvr-stars]');
    var rvrTitle = rvrModal.querySelector('[data-rvr-title]');
    var rvrQuote = rvrModal.querySelector('[data-rvr-quote]');
    var rvrName = rvrModal.querySelector('[data-rvr-name]');
    var rvrVerified = rvrModal.querySelector('[data-rvr-verified]');

    // Only offer "Read more" on cards whose text is actually cut off.
    var markClamped = function () {
      document.querySelectorAll('.rev .rev-body').forEach(function (body) {
        var card = body.closest('.rev');
        if (!card) return;
        card.classList.toggle('is-clamped', body.scrollHeight - body.clientHeight > 2);
      });
    };
    markClamped();
    window.addEventListener('resize', markClamped);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(markClamped);

    var closeRvr = function () {
      rvrModal.classList.remove('open');
      document.body.style.overflow = '';
    };

    document.addEventListener('click', function (e) {
      var card = e.target.closest('[data-rev-open]');
      if (card) {
        e.preventDefault();
        var n = parseInt(card.getAttribute('data-stars'), 10) || 5;
        if (rvrStars) rvrStars.textContent = '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
        var t = card.getAttribute('data-title') || '';
        if (rvrTitle) { rvrTitle.textContent = t; rvrTitle.hidden = !t; }
        if (rvrQuote) rvrQuote.textContent = card.getAttribute('data-quote') || '';
        if (rvrName) rvrName.textContent = card.getAttribute('data-name') || '';
        if (rvrVerified) rvrVerified.hidden = !card.getAttribute('data-verified');
        rvrModal.classList.add('open');
        document.body.style.overflow = 'hidden';
        return;
      }
      if (e.target.closest('[data-rev-close]')) closeRvr();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && rvrModal.classList.contains('open')) closeRvr();
    });
  }

  /* ---------- Review modal ---------- */
  var rvModal = document.getElementById('rvModal');
  if (rvModal) {
    var rvProductInput = document.getElementById('rvProduct');
    var rvProductLabel = rvModal.querySelector('[data-review-product]');
    var rvForm = document.getElementById('rvForm');
    var rvFormWrap = rvModal.querySelector('.rv-form-wrap');
    var rvThanks = rvModal.querySelector('.rv-thanks');
    var openReview = function (name, handle) {
      if (rvProductInput) rvProductInput.value = (name || '') + (handle ? ' (' + handle + ')' : '');
      if (rvProductLabel) rvProductLabel.textContent = name || 'this piece';
      if (rvFormWrap) rvFormWrap.style.display = '';
      if (rvThanks) rvThanks.style.display = 'none';
      rvModal.classList.add('open');
      document.body.style.overflow = 'hidden';
    };
    var closeReview = function () { rvModal.classList.remove('open'); document.body.style.overflow = ''; };
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-review-open]');
      if (opener) { e.preventDefault(); openReview(opener.getAttribute('data-product'), opener.getAttribute('data-handle')); return; }
      if (e.target.closest('[data-review-close]')) closeReview();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeReview(); });
    var rvStars = document.getElementById('rvStars');
    var rvRating = document.getElementById('rvRating');
    if (rvStars && rvRating) {
      rvStars.querySelectorAll('.rv-star').forEach(function (star) {
        star.addEventListener('click', function () {
          var v = +star.getAttribute('data-v');
          rvRating.value = v;
          rvStars.querySelectorAll('.rv-star').forEach(function (s) { s.classList.toggle('on', +s.getAttribute('data-v') <= v); });
        });
      });
    }
    if (rvForm) {
      rvForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var sbtn = rvForm.querySelector('[type=submit]');
        if (sbtn) sbtn.disabled = true;
        fetch(rvForm.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(rvForm) })
          .catch(function () {})
          .then(function () {
            if (rvFormWrap) rvFormWrap.style.display = 'none';
            if (rvThanks) rvThanks.style.display = 'block';
          });
      });
    }
  }
})();
